import { styled } from '@mui/material'

export const LayoutContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: '240px 1fr',
  padding: '0',
  margin: '0',
})
